import { PureNewsLetter } from '../types';
import clsx from 'clsx';
import CtaLink from 'components/helpers/Atoms/Cta/CtaLink';
import useDictionary from 'lib/hooks/useDictionary';
import styles from './Newsletter.module.scss';
import { useSessionSafe } from 'lib/hooks/auth/useSessionSafe';

type NewsletterProps = { data?: PureNewsLetter };
const Newsletter: React.FC<NewsletterProps> = ({ data }) => {
  const { status } = useSessionSafe();
  const { getDictionaryValue } = useDictionary();
  const isVisible = status !== 'authenticated';
  const renderCTA = () => {
    const cta = data?.cta as {
      linkField?: { value?: { href?: string; text?: string; target?: string } };
    };
    if (!cta?.linkField?.value?.href) return null;
    const text =
      (cta.linkField.value.text ?? '').trim() ||
      getDictionaryValue('Navigation.Footer.Newsletter.SubscribeText');

    return (
      <CtaLink
        url={cta.linkField.value.href}
        target={cta.linkField.value.target}
        ctaStyle="link"
        ctaComponentClass="componentTheme-cards-on-surface-text-primary"
        className={clsx(styles.newsButton, styles.newsBase, styles.newsLink)}
      >
        <span>{text}</span>
      </CtaLink>
    );
  };
  return isVisible ? (
    <section>
      <div className={styles.newsletterContent}>
        {data?.headline && <h2 className={styles.newsletterheading}>{data.headline}</h2>}
        {data?.description && <p className={styles.newsletterDesc}>{data.description}</p>}
        {data?.cta && <div className={styles.newsletterLinkBtn}>{renderCTA()}</div>}
      </div>
    </section>
  ) : null;
};
export default Newsletter;
